import React from 'react';
import type { RuleCalloutProps } from '../../types/rules';
import { Lightbulb, AlertTriangle, Info } from 'lucide-react';

/**
 * RuleCallout component for displaying tips, warnings, or notes.
 * Uses a discriminated union for the type prop with exhaustiveness checking.
 */
export function RuleCallout({ type, children }: RuleCalloutProps) {
  const calloutConfig = {
    tip: {
      containerClass: 'bg-blue-50 border-blue-200',
      icon: Lightbulb,
      iconClass: 'text-blue-600',
      title: 'Pro Tip',
    },
    warning: {
      containerClass: 'bg-yellow-50 border-yellow-200',
      icon: AlertTriangle,
      iconClass: 'text-yellow-600',
      title: 'Warning',
    },
    note: {
      containerClass: 'bg-gray-50 border-gray-200',
      icon: Info,
      iconClass: 'text-gray-600',
      title: 'Note',
    },
  };

  const config = calloutConfig[type];
  const Icon = config.icon;

  return (
    <div
      className={`border-l-4 rounded-r-lg p-4 my-4 ${config.containerClass}`}
    >
      <div className="flex items-start gap-3">
        <Icon className={`w-5 h-5 mt-0.5 flex-shrink-0 ${config.iconClass}`} />
        <div>
          <span className="font-semibold text-sm uppercase tracking-wide">
            {config.title}
          </span>
          <div className="mt-1 text-gray-700">{children}</div>
        </div>
      </div>
    </div>
  );
}
